// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();


// const api = new apiDrupal();
export const page = async () => {
    //DESPLIEGA MENU MOBILE DEL HEADER
    var body = document.querySelector("body");
    var iconMenuMobile = document.getElementById("icon-tab-menu");
    var containerNav = document.getElementById("container-nav");

    iconMenuMobile.onclick = function() {
        containerNav.classList.toggle("menu-mobile-active");
        iconMenuMobile.classList.toggle("menuMobile-active");

        if (containerNav.classList.contains("menu-mobile-active")){
            body.style.position = "static";
            body.style.height = "100%";
            body.style.overflow = "hidden";
        } else {
            body.style.position = "inherit";
            body.style.height = "auto";
            body.style.overflow = "visible";
        }
    }
    //END
}

let container = document.querySelector('nav[role="navigation"]') as any;
if(container){
    const e = document.querySelector('nav[role="navigation"] .visually-hidden');
    e && e.parentElement.removeChild(e);;

    const el = document.querySelector('#block-subtheme-vmlyr-main-menu-menu');
    el && el.parentElement.removeChild(el);
}